import {DataType, IPublisher} from '../ipublisher';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {TypedJSON} from 'typedjson';
import {DataGrid} from '../../DoraData/data-grid';
import {IConfigurationCaller} from '../../Configuration/iconfiguration-caller';
import {DoraProperty} from '../../Decorators/Decorator';
import {Observable} from 'rxjs';
import {ComponentType} from '../../Configuration/component-type.enum';
import {IPublisherInitializer} from '../ipublisher-initializer';
import {ConfigurationService} from '../../Configuration/configuration-service';
import {DataRow} from 'src/app/DoraData/data-row';
import {DataSeries} from '../../DoraData/data-series';
import {ReadResult} from '../data/read-result';

declare function DoraGetLocale(): string;

export class PublisherDoraServer implements IPublisher, IConfigurationCaller {

    @DoraProperty
    private baseUrl = '';

    private language = 'it'; // todo questo deve essere presa in get

    @DoraProperty
    private progressive = '1';

    @DoraProperty
    private isinSearch = false;

    private initializer: IPublisherInitializer = undefined;

    constructor(private http: HttpClient,
                progressive: string) {

        this.progressive = progressive;

        // set language
        this.language = DoraGetLocale();
    }

  // tslint:disable-next-line:ban-types max-line-length
    read(publisherParameters: Map<string, string>, subscribeObjInfo: string[], dataType: DataType, callerData: any): Observable<Object> {
        switch (dataType) {
          case DataType.ROW:
          case DataType.HISTORICAL:
            const completeUrl = this.baseUrl + 'sections/' +
              subscribeObjInfo[0] + '/' + this.dataType2String(dataType) +
              this.getParameterForUrl(publisherParameters);

            console.log('Call URL: ' + completeUrl);

            return this.readSingleContent(subscribeObjInfo[0], completeUrl, dataType, callerData);

          case DataType.ROWS:
            return this.readRows(publisherParameters, subscribeObjInfo, callerData);

          default:
            let empty: string;
            empty = '';
            // @ts-ignore
            return empty;
        }
    }
  // tslint:disable-next-line:ban-types
    private readSingleContent(subscribeId: string, completeUrl: string, dataType: DataType, callerData: any): Observable<Object> {
      return this.http.jsonp(completeUrl, 'callback').pipe(map((data: any) => {

          switch (dataType) {
            case DataType.ROW: {

              // decode DataGrid
              let dataRow: DataRow;
              const dataRowSerialized = new TypedJSON(DataRow);


              dataRow = dataRowSerialized.parse(data);
              return new ReadResult(callerData, dataRow);
            }
              case DataType.GRID: {

                  // decode DataGrid
                  let dataGrid: DataGrid;
                  const dataRowSerialized = new TypedJSON(DataGrid);


                  dataGrid = dataRowSerialized.parse(data);
                  return new ReadResult(callerData, dataGrid);
              }
            case DataType.HISTORICAL: {
              // decode DataSeries
              let dataSeries: DataSeries;
              const dataSeriesSerialized = new TypedJSON(DataSeries);


              dataSeries = dataSeriesSerialized.parse(data);
              dataSeries.SubscribeId = subscribeId;
              return new ReadResult(callerData, dataSeries);
            }
          }
          return new ReadResult(callerData, '');
        }),
        catchError((error: HttpErrorResponse) => {
          return '';
        }));
    }
    private dataType2String(dataType: DataType): string {

      switch (dataType) {
        case DataType.ROW:
          return 'TUPLAS';
        case DataType.HISTORICAL:
          return 'HISTORICAL';
        default:
          return 'Type Undefined';
      }
    }

  /**
   * Read rows and build a unique grid
   */
  // @ts-ignore
  // tslint:disable-next-line:ban-types
    private readRows(publisherParameters: Map<string, string>, subscribeObjInfo: string[], callerData: any): Observable<Object> {
      let idSectionsParameter = '';


      subscribeObjInfo.forEach(value => {

        if (idSectionsParameter !== '') {
            idSectionsParameter += ',';
        }

        idSectionsParameter += value;
      });

      publisherParameters.set('idsections', idSectionsParameter);

      const completeUrl = this.baseUrl +
          'multipleSections' +
          this.getParameterForUrl(publisherParameters);

      console.log('Call URL: ' + completeUrl);

      let readResult: ReadResult;
      // @ts-ignore
      readResult = this.readSingleContent('-', completeUrl, DataType.GRID, callerData);

      // @ts-ignore
      return readResult;
    }
  // IConfigurationCaller methods
  // TODO bisogna costruire un servizio che istanzia queste classi e rendere parametrica questi parametri
  get CallerName(): string {
      return 'DataManager1';
  }
  get CallerProgressive(): string {
      return this.progressive;
  }
  get CallerSubType(): string {
      return 'DoraServer';
  }
  get CallerType(): ComponentType {
      return ComponentType.Publishers;
  }

    setCallerProgressive(progressive: string): void {
        this.progressive = progressive;
    }

    initialize(initializer: IPublisherInitializer, configuration: ConfigurationService) {
      this.initializer = initializer;
      configuration.injectParametersToComponent(this);
    }

    getRewritableParameterMap(): Map<string, string> {
        const result: Map<string, string> = new Map<string, string>();

        // language
        result.set('language', this.language);

        // Add format
        result.set('format', 'json');

        // Add isin search
        if (this.isinSearch) {
            result.set('flIsin', 'true');
        }
        return result;
    }

    private getParameterForUrl(parameters: Map<string, string>): string {
        let result = '';

        let first = true;
        parameters.forEach((value: string, key: string) => {
            if (first) {
                first = false;
                result += '?';
            } else {
                result += '&';
            }

            result += (key + '=' + value);
        });

        return result;
    }
  onParameterInjectedFinished(): void {
      // adjust baseurl
    // this.baseUrl += '?project=' + this.project + '&language=' + this.language + '&xlsxid=' + this.xlsxid;

    // signal event
    this.initializer.onPublisherInitialized();
  }
}
